export default __webpack_public_path__ + "static/heart_red-3199834b42b7e4659b389c81e6285f85.png";